import dynamic from 'next/dynamic';

const esadirComponents = {

    Capcalera: { dynamicComponent: dynamic(() => import(`components/esadir/MenuExtern`)) },
    Cercador: { dynamicComponent: dynamic(() => import(`components/esadir/Cercador`)) },
    Columna: { dynamicComponent: dynamic(() => import(`components/corporatiu/Columna`)) },
    Contenidor: { dynamicComponent: dynamic(() => import(`components/corporatiu/Contenidor`)) },
    ContingutEstatic: { dynamicComponent: dynamic(() => import(`components/esadir/ContingutEstatic`)) },
    ContingutsMovil: { dynamicComponent: dynamic(() => import(`components/esadir/ContingutsMovil`)) },
    Destacat: { dynamicComponent: dynamic(() => import(`components/esadir/Destacat`)) },
    Enllac: { dynamicComponent: dynamic(() => import(`components/corporatiu/Enllac`)) },
    Fila: { dynamicComponent: dynamic(() => import(`components/corporatiu/Fila`)) },
    FilAriadna: { dynamicComponent: dynamic(() => import(`components/esadir/FilAriadna`)) },
    Header: { dynamicComponent: dynamic(() => import(`components/esadir/Header`)) },
    ItemMock: { dynamicComponent: dynamic(() => import(`components/esadir/ItemMock`)) },
    LlistaEnllacos: { dynamicComponent: dynamic(() => import(`components/esadir/LlistaEnllacos`)) },
    Menu: { dynamicComponent: dynamic(() => import(`components/esadir/Menu`)) },
    Metadades: { dynamicComponent: dynamic(() => import(`components/esadir/Metadades`)) },
    Peu: { dynamicComponent: dynamic(() => import(`components/corporatiu/Peu`)) },
    Subtitol: { dynamicComponent: dynamic(() => import(`components/esadir/Subtitol`)) },
    Text: { dynamicComponent: dynamic(() => import(`components/esadir/Text`)) },
    Titol: { dynamicComponent: dynamic(() => import(`components/corporatiu/Titol`)) },
    
};

export { esadirComponents };
